import http from 'hub-http/clients/apiClient';
import GDPRRecord from 'documents-ui/records/GDPRRecord';
import { fetchWithEarlyRequestHook } from './quickFetchHelper';
import { createRpcClientV2, makeChirpEarlyRequest } from 'rpc-client-utils';
import { updateSettingsRpc } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsGDPRService';
import { getGdprWrapEarlyRequestRpc } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/earlyRequest/SalesDocumentsGDPRService.early';
const gdprUrl = 'presentations/v1/gdpr/decks';
export const fetchGDPRSettingsCHIRP = deckId => makeChirpEarlyRequest(getGdprWrapEarlyRequestRpc, {
  request: {
    documentId: deckId
  }
});
export function fetchGDPRSettings(deckId) {
  const fallbackFetch = () => http.get(`${gdprUrl}/${deckId}/settings`);
  const successHandler = gdprData => GDPRRecord(gdprData);
  return fetchWithEarlyRequestHook('document-gdpr-settings', fallbackFetch, successHandler);
}
export function updateGDPRSetting({
  deckId,
  legalConsentEnabled
}) {
  return http.put(`${gdprUrl}/${deckId}/settings`, {
    data: {
      legalConsentEnabled
    }
  }).then(gdprData => GDPRRecord(gdprData));
}
export function updateGDPRSettingCHIRP(deckId, legalConsentEnabled) {
  const rpcClient = createRpcClientV2({
    hubHttpClient: http
  });
  return rpcClient.call(updateSettingsRpc, {
    request: {
      documentId: deckId,
      request: {
        legalConsentEnabled
      }
    }
  });
}